module.exports = __webpack_public_path__ + "static/img/vivoY70S.e1390e48.png";